export class AssetFilterModel {
  customerId: string;
  siteId: string;
  serialNumber: string;
  showInactive: true | false | '';
  assetType: string;
  assetTagPresent: string;
  tag: string;
  make: string;
  makeId: string;
  model: string;
  createdDate: Date;
  updatedDate: Date;
  updatedBy: string;
}
export class AssetStoreFilter {
  selectedCustomer: Array<any>;
  selectedAssetType: Array<any>;
}
